interface Props {
  number: number;
}

export const NumberBadge = ({ number }: Props) => {
  return (
    <div className="bg-success_color rounded-full flex items-center justify-center min-w-[14px] h-[14px] px-[2px]">
      <span className="text-sm text-white font-medium">{`+${number}`}</span>
    </div>
  );
};
